export default {"src":"/_next/static/media/star.a4f753ff.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};